<template>
  <modal class="modal--welcomeback modal--zero-balance" :modal-key="'profile_change_username_modal'" @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_change_username_title }}</h1>
      <img class="pinicon" src="static/images/username.svg" alt="">
    </template>
    <template slot="body">
      <form action="">
        <div :class="['form-group sml_mrgn', hasErrors ? 'has-warning' : '']">
          <input type="text"
                 v-model="username"
                 @keyup="validateUsername($event)"
                 class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_change_username_placeholder" />
          <span class="form-group__feedback"
                v-if="hasErrors">
               {{ getMessage }}
              </span>
        </div>
        <input type="submit"
               :value="getTranslations.home_modals_change_username_save"
               @click.prevent="updateUsernameAction()"
               :class="['btn2 btn2--std btn2--small btn2--fixed', hasErrors || !username ? 'deactivated' : '']">
        <div class="success_msg" v-if="success">
          <p>{{ getTranslations.home_modals_change_username_success }}</p>
        </div>
      </form>
      <p class="note">
        <img src="static/images/info.svg">
        {{ getTranslations.home_modals_change_username_note }}
      </p>
    </template>
  </modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import ValidationMixin from '@/common/mixins/validations';

export default {
  name: 'change-username',
  mixins: [ValidationMixin],
  components: {
    Modal,
  },
  methods: {
    ...mapActions('profile', [
      'changeUsername',
      'storeLoginInfo',
    ]),
    ...mapMutations('common', [
      'updateUsername',
    ]),
    updateUsernameAction() {
      this.clearMessages();
      if (!this.username) return;
      this.changeUsername({ username: this.username }).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.setSuccess(true);
          this.updateUsername(this.username);
          this.storeLoginInfo({ token: response.data.data, username: this.username, rememberMeParameter: true });
        } else {
          this.setError(true);
          this.setResult('home_modals_change_username_error');
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/ChangeUsername.vue